export const useCasesData = [{
    role: "Students, Researchers, Librarians",
    usecases:
             <ul>
                <li>Digitize handwritten notes, scanned books, historical documents and academic journals</li>
                <li><mark>No more copying notes by hand - Scan and Save instantly</mark></li>
             </ul> 
}, {
   role: "Accountants and Bookkeepers",
   usecases:
            <>
               <ul>
                  <li><mark>Quickly extract financial data</mark> for entry into accounting software</li> 
                  <li>Save hours of manual work</li>
                  <li>Minimize errors</li>
               </ul> 
               <div style={{textAlign: 'left', marginLeft: '20px'}}><a href="https://medium.com/@sriram_54837/the-simple-ocr-tool-thats-saving-finance-professionals-hours-every-week-731e7c461ce4" target="_blank"><b>See a real user case</b></a></div>
            </>
}, {
    role: "Government Analysts",
    usecases:
             <>
               <ul>
                  <li><mark>Extract scanned purchase forms into Google Sheets</mark> in seconds.</li>
               </ul>
               <div style={{textAlign: 'left', marginLeft: '20px'}}><a href="https://medium.com/@sriram_54837/how-government-analysts-can-extract-purchase-data-into-google-sheets-instantly-6c765c0fb8d0" target="_blank"><b>See a real user case</b></a></div>
             </> 
}, {
   role: "Data Entry / BPO Professional",
   usecases:
            <>
               <ul>
                  <li>Automate data extraction</li> 
                  <li><mark>Meet high-volume quotas</mark></li>
                  <li>Reduce manual typing errors</li>
               </ul> 
               <div style={{textAlign: 'left', marginLeft: '20px'}}><a href="https://medium.com/@sriram_54837/the-simple-ocr-tool-thats-saving-finance-professionals-hours-every-week-731e7c461ce4" target="_blank"><b>See a real user case</b></a></div>
            </>
}, {
   role: "Virtual Assistant",
   usecases:
            <ul>
               <li>Quickly digitize business cards</li> 
               <li>Transcribe notes from screenshots</li>
               <li><mark>Convert scanned contracts into editable formats</mark></li>
            </ul> 
}, {
   role: "Legal Professional",
   usecases:
            <ul>
               <li><mark>Convert scanned case files, photo evidences into searchable text</mark></li>
               <li>Extract clauses from contracts instantly</li>
               <li>Digitize to search for specific legal precedents, quote passages</li>
            </ul> 
}, {
    role: "Healthcare Professional",
    usecases:
             <ul>
                <li><mark>Scan handwritten patient notes</mark> for quick digital access.</li>
                <li>Turn medical prescriptions into searchable text instantly.</li>
             </ul> 
}, {
    role: "Journalist",
    usecases:
             <ul>
                <li>Digitize handwritten interview notes instantly.</li>
                <li><mark>Extract quotes or headlines from newspaper clippings</mark>.</li>
                <li>Turn on-field posters or documents into editable, searchable text.</li>
             </ul> 
}, {
    role: "Traveler",
    usecases:
             <ul>
                <li><mark>Translate text from images instantly (100+ languages supported)</mark></li>
                <li>Digitize travel receipts, tickets, or handwritten notes.</li>
             </ul> 
}, {
    role: "Teacher",
    usecases:
             <ul>
                <li>Save board writings or notes for reuse and sharing.</li>
                <li>Turn handwritten student work into digital text.</li>
                <li>Turn scanned worksheets or lesson PDFs into class presentations instantly using <a style={{fontWeight: 550, color: 'darkred'}} href="https://workspace.google.com/marketplace/app/convert_pdf_to_google_slides/496987605713" target="_blank" rel="noopener">Convert PDF to Google Slides</a></li>
             </ul> 
}, {
    role: "Software Developer / Coder",
    usecases:
             <ul>
                <li>Instantly extract code from screenshots shared in chats or forums.</li>
                <li>Extract code snippets from online tutorials without retyping.</li>
             </ul> 
}]